import goodsApi from '@/api/masterData/goods.js';
export default {
  props: {
    commodityClassificationRow: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      productCategoryId: null, //商品分类id
      productId: null, //商品父类id
      commoditySpecificationsList: [], //商品规格下拉列表
      packList: [], //包装下拉列表
    };
  },
  watch: {
    // 商品分类下拉列表
    goodsCategoryRow: {
      handler(val) {
        if (val && val.length) {
          this.goodsCategoryAll = val;
        } else {
          this.goodsCategoryAll = [];
        }
      },
    },
    // 商品分类下拉列表
    commodityClassificationRow: {
      handler(val) {
        if (val && val.length) {
          this.commodityClassificationList = val;
          this.commodityClassificationList = this.commodityClassificationList.map((item) => {
            return {
              ...item,
              value: item.categoryCode,
              label: item.categoryName,
            };
          });
          console.log('商品分类', this.commodityClassificationList);
        } else {
          this.commodityClassificationList = [];
        }
      },
    },
  },
  methods: {
    async queryAttr(productId, attrType) {
      console.log('productCategoryId', this.productCategoryId);
      const productCategoryId = [this.productCategoryId];
      let res = await this.$axios.post(goodsApi.GOODS_QUERY_ATTR, {
        productCategoryId,
        productId,
        attrType,
      });
      if (res.data.code === 0) {
        // this.commoditySpecificationsList = res.data.data.records || [];
        return res.data.data.records || [];
      } else {
        this.$alert(res.data.msg);
      }
    },
    // 激活下拉框的时候(04-规格，05-包装)
    async focusHandler(row, attrType) {
      if (
        !row.commodityCategoryCode?.length ||
        (row.commodityCategoryCode?.length && !row.commoditySpecificationsList?.length)
      ) {
        if (attrType == '04') {
          this.commoditySpecificationsList = await this.queryAttr(row.commodityTypeId, attrType);
        } else {
          this.packList = await this.queryAttr(row.commodityTypeId, attrType);
        }
      } else {
        if (attrType == '04') {
          this.commoditySpecificationsList =
            row.commoditySpecificationsList.map((item) => {
              return {
                ...item,
                id: item.detailProductModelId,
                name: item.detailProductModel,
              };
            }) || [];
        } else {
          this.packList =
            row.detailProductPacksList.map((item) => {
              return {
                ...item,
                id: item.detailProductPacksId,
                name: item.detailProductVendor,
              };
            }) || [];
        }
      }
    },
    changecommoditySpecifications(val, row, attrType) {
      if (val.length) {
        if (attrType == '04') {
          let commoditySpecificationsList = [];
          this.commoditySpecificationsList.map((item) => {
            if (val.includes(item.id)) {
              commoditySpecificationsList.push(item.name);
            }
          });
          row.commoditySpecifications = commoditySpecificationsList.join(',');
        } else {
          let packlist = [];
          packlist = this.packList
            .filter((item) => val.includes(item.id))
            ?.map((item) => {
              return item.name;
            });
          row.packing = packlist.join(',');
        }
      } else {
        row.commoditySpecifications = '';
        row.packing = '';
      }
    },
  },
};
